import { t } from '@lingui/macro';

export function getItemName(name: string) {
  return name === 'ROOT' ? t`Main Page` : name;
}
